import React, { useState } from 'react';

import { EditorColumn } from 'leeloo-react/component/dataTable/column/EditorColumn';
import { PriceColumn } from 'leeloo-react/component/dataTable/column/PriceColumn';
import { SimpleColumn } from 'leeloo-react/component/dataTable/column/SimpleColumn';
import { DataTable } from 'leeloo-react/component/dataTable/DataTable';
import { Filter } from 'leeloo-react/component/filter/Filter';
import { InputField } from 'leeloo-react/component/form/field/InputField';
import { useDataSource } from 'leeloo-react/component/hook/useDataSource';

import { ResourceDataProviderEnum } from '../../../../enum/ResourceDataProviderEnum';
import { RouteEnum } from '../../../../enum/RouteEnum';
import { CustomFilterDataProviderType } from '../../../../model/dataProvider/CustomFilterDataProviderType';
import { LengthColumn } from '../../../dataTable/column/LengthColumn';
import { ListColumn } from '../../../dataTable/column/ListColumn';
import { DataTableBulksActions } from '../../../dataTable/DataTableBulksActions';
import { DataTableHeaderActions } from '../../../dataTable/DataTableHeaderActions';
import { DataTableListActions } from '../../../dataTable/DataTableListActions';
import { SwitchField } from '../../../form/SwitchField';

export function OnSiteDataTable() {
  const [filters, setFilters] = useState<CustomFilterDataProviderType>({});
  const dsTrainings = useDataSource({
    resource: ResourceDataProviderEnum.training,
    params: {
      pagination: { page: 1, take: 50 },
      filter: { adminList: true },
    },
  });
  const exportNameFile = 'actions_formation.csv';

  return (
    <DataTable
      dataSource={dsTrainings}
      filter={(
        <Filter>
          <InputField name="search" label="Rechercher" onChangeValue={(v) => setFilters({ search: v })} />
        </Filter>
      )}
      actionHeader={(
        <DataTableHeaderActions
          addRoute={RouteEnum.ADMIN_ON_SITE_ADD}
          addRouteValue="Créer une action de formation"
          importResource={ResourceDataProviderEnum.trainingImport}
          exportResource={ResourceDataProviderEnum.trainingExport}
          exportNameFile={exportNameFile}
          exportFilters={filters}
          dataSource={dsTrainings}
        />
      )}
      actionRow={(row) => [
        <DataTableListActions
          key={0}
          row={row}
          dataSource={dsTrainings}
          readRoute={RouteEnum.ADMIN_ON_SITE_SHOW}
          deleteResource={ResourceDataProviderEnum.training}
          duplicateResource={ResourceDataProviderEnum.trainingDuplicate}
          editRoute={RouteEnum.ADMIN_ON_SITE_EDIT}
        />,
      ]}
      onChangeCheckedRow={(rows: {id: number|string}[], cleanSelection) => (
        <DataTableBulksActions
          rows={rows}
          dataSource={dsTrainings}
          deleteResource={ResourceDataProviderEnum.training}
          duplicateResource={ResourceDataProviderEnum.trainingDuplicate}
          exportResource={ResourceDataProviderEnum.trainingExport}
          exportNameFile={exportNameFile}
          cleanSelection={cleanSelection}
        />
      )}
    >
      <SimpleColumn field="title" title="Action de formation" sortable />
      <ListColumn field="themes" fieldColumns="theme.name" fieldKey="theme.id" title="Thème" />
      <SimpleColumn field="duration" title="Durée" sortable />
      <LengthColumn field="sessions" title="Sessions" />
      <PriceColumn field="cost" title="Cout total" sortable />
      <EditorColumn
        field="status"
        title="Status"
        resource={ResourceDataProviderEnum.trainingUpdateStatus}
        columnElement={SimpleColumn}
        inputElement={<SwitchField />}
        center
        sortable
        forceEditable
      />
    </DataTable>
  );
}
